export default "__VITE_ASSET__D8R7Bjkk__"